"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CatalogTileTooltip_module_scss_1 = __importDefault(require("./CatalogTileTooltip.module.scss"));
function CatalogTileTooltip({ imageURI, label }) {
    return (react_1.default.createElement("div", { className: CatalogTileTooltip_module_scss_1.default.tooltip },
        react_1.default.createElement("div", null, label)));
}
exports.default = CatalogTileTooltip;
